import React from "react";

const Header = () => {
  return (
    <div className="d-flex align-items-center">
      <img src="/images/10314.jpg" alt="" />
      <h1>Fruits Lover Club</h1>
    </div>
  );
};

export default Header;
